import FaqButton from '@/components/common/FaqButton';
import ModalFrame from '@/components/common/ModalFrame';
import styled from 'styled-components';
import { useAppDispatch } from '@/hooks/useReduxHooks';
import { useHistory } from 'react-router-dom';
import { routes } from '@/constant/routes.const';

type Props = {
  onClose?: () => void;
};

function DepartureRefundInfoModal({ onClose }: Props) {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const onClickRefundInfo = () => {
    dispatch({
      type: 'UPDATE_USER_INFO',
      payload: {
        isDepartureCheckRequired: false,
      },
    });
    history.push(routes.medicalCustomerRefund);
  };

  return (
    <ModalFrame
      title={
        <TitleWrapper>
          <Title>송금 정보 입력</Title>
        </TitleWrapper>
      }
      content={
        <GuideWrapper>
          <GuideText>환급금 송금을 위해 계좌 정보를 입력해주세요.</GuideText>
          <GuideText>정보 입력 후 출국 확인 단계로 넘어갑니다.</GuideText>
          <WarningText>*송금 정보 확인 후 14일 이내 송금됩니다.</WarningText>
        </GuideWrapper>
      }
      buttons={
        <Footer>
          <FaqButton
            status='active'
            width='100%'
            padding='10px 0'
            fontSize={16}
            onClick={onClickRefundInfo}
          >
            송금 정보 입력
          </FaqButton>
          <CloseButton onClick={onClose}>닫기</CloseButton>
        </Footer>
      }
    />
  );
}

export default DepartureRefundInfoModal;

type StyleProps = {
  isDeparture: boolean;
};

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
`;
const Title = styled.strong`
  display: block;
  font-size: 16px;
`;

const GuideWrapper = styled.ul`
  display: flex;
  margin-bottom: 16px;
  flex-direction: column;
`;

const GuideText = styled.p`
  color: #5f6165;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%; /* 21px */
`;

const WarningText = styled(GuideText)`
  color: #80848a;
  margin-top: 16px;
`;

const CloseButton = styled.div`
  font-size: 13px;
  color: #80848a;
  text-decoration: underline;
`;

const Footer = styled.footer`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
`;
